import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "components/Graphs/Button";
import type {
  ComputeListFilters,
  ComputeListFilterUpdate,
} from "./hooks/useComputeListFilters";

const filterChipClassName =
  "group h-auto gap-1.5 rounded-md border border-zinc-700 bg-zinc-900/60 py-1 pl-2.5 pr-1.5 text-xs font-normal transition hover:border-zinc-500 hover:bg-zinc-800";

interface AppliedFilter {
  buttonClassName?: string;
  key: string;
  label: string;
  onClear: () => void;
  value: string;
  valueClassName: string;
}

const AppliedFilterChips: React.FC<{
  creatorLabel?: string;
  filters: ComputeListFilters;
  setFilters: (filters: ComputeListFilterUpdate) => void;
}> = ({ creatorLabel, filters, setFilters }) => {
  const candidateFilters: Array<AppliedFilter | null> = [
    creatorLabel
      ? {
          buttonClassName: "text-secondary hover:text-primary",
          key: "creator",
          label: "Creator",
          onClear: () => setFilters({ creatorId: "all", ownership: "all" }),
          value: creatorLabel,
          valueClassName: "text-primary",
        }
      : null,
    filters.status !== "all"
      ? {
          key: "status",
          label: "Status",
          onClear: () => setFilters({ status: "all" }),
          value: filters.status,
          valueClassName: "capitalize text-primary",
        }
      : null,
    filters.network !== "all"
      ? {
          key: "network",
          label: "Network",
          onClear: () => setFilters({ network: "all" }),
          value: filters.network,
          valueClassName: "capitalize text-primary",
        }
      : null,
  ];
  const appliedFilters = candidateFilters.filter(
    (filter): filter is AppliedFilter => filter !== null,
  );

  if (appliedFilters.length === 0) return null;

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      {appliedFilters.map((filter) => (
        <Button
          key={filter.key}
          type="button"
          variant="ghost"
          onClick={filter.onClear}
          className={`${filterChipClassName} ${filter.buttonClassName || ""}`}
        >
          <span className="text-[#909090]">{filter.label}</span>
          <span className={filter.valueClassName}>{filter.value}</span>
          <XMarkIcon className="h-3.5 w-3.5 text-[#707070] transition group-hover:text-primary" />
        </Button>
      ))}
    </div>
  );
};

export default AppliedFilterChips;
